import { NgModule } from '@angular/core';
import { UserSharedModule } from '@kitch/user/shared/user-shared.module';
import { UpcomingStreamsComponent } from './components/upcoming-streams/upcoming-streams.component';
import { ScheduledStreamsRoutingModule } from './scheduled-streams-routing.module';

@NgModule({
  declarations: [UpcomingStreamsComponent],
  imports: [ScheduledStreamsRoutingModule, UserSharedModule],
})
export class ScheduledStreamsModule {
}
